import { useState } from 'react'

import { SankeyContainer, SingleSankey } from './sankey'
import { StagedFlowControls } from './staged-flow-controls'
import { ControlBar as SankeyControlBar } from './control-bar'
import { formatService } from '../common/format.service'

import { useStyles } from './sankey-block.style'
import { SplitChartFilterBar } from '../split-chart-filter-bar'
import { ChartLoader } from '../chart-loader'
import { SideBySideChart } from '../side-by-side-chart'
import { reportDataSetService } from '../../editor/report-data-set.service'
import { SideBySideChartContainer } from '../side-by-side-chart-container'

const LEGEND_HEIGHT = 78

export const SankeyBlockWidget = function ({
  report,
  blockKey,
  dataKey,
  sliderDefinition,
  filterDefinition,
  selections,
  splitChart = false,
  width,
  height,
  onDataLoad,
  datasets,
  labels,
  stateLabels,
  ...props
}) {
  const classes = useStyles()

  const [splitChartSelections, setSplitChartSelections] = useState(
    reportDataSetService.getFilterDefinitionSplitChartSelections(filterDefinition)
  )

  const chartWidth = splitChart ? width / 2 + 12 : width
  const chartHeight = splitChart ? (height - LEGEND_HEIGHT) / 1.25 : height - LEGEND_HEIGHT

  const missingSideBySideChartStyle = {
    width: 476,
    height: 360
  }

  return (
    <ChartLoader report={report} blockKey={blockKey} dataKey={dataKey} sliderDefinition={sliderDefinition} selections={selections} splitChart={splitChart} splitChartSelections={splitChartSelections} width={width} initialHeight={chartHeight} onDataLoad={onDataLoad}>
      <SankeyContainer
        datasets={datasets}
        width={chartWidth}
        height={chartHeight}
        {...props}
        {...labels}
      >
        {({
          sankeyDatasets,
          onStagedFlowSelect,
          ...sankeyProps
        }) => {
          return sankeyDatasets && sankeyDatasets && sankeyDatasets.length ? (
            <>
              <StagedFlowControls onSelect={onStagedFlowSelect} {...props} />
              <div data-qa="sankey-control-bar" style={{ width }}>
                <SankeyControlBar
                  totalSize={sankeyDatasets[0].getStageTotalSize(0)}
                  valueLabel={sankeyDatasets[0].layout.valueLabel}
                  stateColors={sankeyDatasets[0].layout.stateColors}
                  stateLabels={stateLabels || (labels && labels.stateLabels)}
                  customTotal={splitChart && sankeyDatasets.length > 1 ? (
                    <div className={classes.sideBySideControlBarTotal}>
                      <div data-qa="sankey-left-chart-total">
                        Left Total: {`${formatService.formatNumberRoundedToInteger(sankeyDatasets[0].getStageTotalSize(0))} ${sankeyDatasets[0].layout.valueLabel}`}
                      </div>
                      <div data-qa="sankey-right-chart-total">
                        Right Total: {`${formatService.formatNumberRoundedToInteger(sankeyDatasets[1].getStageTotalSize(1))} ${sankeyDatasets[1].layout.valueLabel}`}<br />
                      </div>
                    </div>
                  ) : null}
                />
              </div>
              {splitChart && sankeyDatasets.length > 1 ? (
                <>
                  {splitChart && <SplitChartFilterBar filterDefinition={filterDefinition} onChange={setSplitChartSelections} className={classes.sideBySideChartFilterBar} />}
                  <SideBySideChartContainer className={classes.sideBySideChartContainer}>
                    <SideBySideChart
                      data={sankeyDatasets && sankeyDatasets[0] && sankeyDatasets[0].clusters && sankeyDatasets[0].clusters.length}
                      missingChartStyles={{ ...missingSideBySideChartStyle, marginLeft: 16 }}
                    >
                      <SingleSankey sankeyData={sankeyDatasets[0]} {...sankeyProps} />
                    </SideBySideChart>
                    <SideBySideChart
                      data={sankeyDatasets && sankeyDatasets[1] && sankeyDatasets[1].clusters && sankeyDatasets[1].clusters.length}
                      missingChartStyles={{ ...missingSideBySideChartStyle }}
                    >
                      <SingleSankey sankeyData={sankeyDatasets[1]} {...sankeyProps} />
                    </SideBySideChart>
                  </SideBySideChartContainer>
                </>
              ) : (
                <SingleSankey sankeyData={sankeyDatasets[0]} {...sankeyProps} width={width} />
              )}
            </>
          ) : null
        }}
      </SankeyContainer>
    </ChartLoader>
  )
}
